@if (authService.offline$ | async; as reason) {
  <div class="container-md flex justify-center items-center">
    @if (reason.maintenance) {
      <app-maintenance-disclaimer />
    } @else {
      <app-offline-disclaimer />
    }
  </div>
} @else if (!authService.token) {
  <div class="container-md flex justify-center items-center">
    <core-icon icon="progress_activity" size="xl" class="text-content-action-primary animate-spin" />
  </div>
} @else {
  <ng-content />
}
